import DataFormat from './DataFormat';

export default DataFormat;
